import { ApplicationTheme } from "@multiweb/uiShared/ApplicationTheme";

/**
 * Ověří, zda je téma validním tématem aplikace.
 * @param theme Název tématu který se má ověřit.
 */
export const isApplicationThemeValid = (theme: string): theme is ApplicationTheme => Object.values(ApplicationTheme).includes(theme as ApplicationTheme);
